import * as Yup from 'yup'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { filterVisibleItems } from '../../../utils/common'

import {
  USER_INVITATION_FORM_FIELD_NAME_MESSAGE,
  USER_INVITATION_FORM_FIELD_NAME_SUBJECT,
  USER_INVITATION_FORM_FIELD_WITH_SMS,
  USER_INVITATION_FORM_NOTIFICATION_ID_INFO,
  USER_INVITATION_FORM_TAB_NAME_EMAIL,
  USER_INVITATION_FORM_TAB_NAME_SMS,
} from './UserInvitationForm.constants'

export function getUserInvitationFormTabs({ smsTab, t }) {
  return filterVisibleItems([
    {
      id: USER_INVITATION_FORM_TAB_NAME_EMAIL,
      isVisible: true,
      text: t('User.EmailInvitationTabKey'),
    },
    {
      id: USER_INVITATION_FORM_TAB_NAME_SMS,
      isVisible: smsTab,
      text: t('User.PhoneInvitationTabKey'),
    },
  ])
}

export function getUserInvitationFormInitialNotifications(t) {
  return [
    {
      id: USER_INVITATION_FORM_NOTIFICATION_ID_INFO,
      text: t('User.SendInvitationInfoKey'),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}

export function getUserInvitationFormInitialValues(values) {
  return {
    [USER_INVITATION_FORM_FIELD_NAME_MESSAGE]:
      values[USER_INVITATION_FORM_FIELD_NAME_MESSAGE],
    [USER_INVITATION_FORM_FIELD_NAME_SUBJECT]:
      values[USER_INVITATION_FORM_FIELD_NAME_SUBJECT],
    [USER_INVITATION_FORM_FIELD_WITH_SMS]:
      values[USER_INVITATION_FORM_FIELD_WITH_SMS],
  }
}

export function getUserInvitationFormValidationSchema() {
  return Yup.object({
    [USER_INVITATION_FORM_FIELD_NAME_MESSAGE]: Yup.string().required(true),
  })
}

export function isUserInvitationFormEmailTab(tabId) {
  return tabId === USER_INVITATION_FORM_TAB_NAME_EMAIL
}

export function isUserInvitationFormSmsTab(tabId) {
  return tabId === USER_INVITATION_FORM_TAB_NAME_SMS
}
